/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose } from 'recompose'
import { connect } from 'react-redux'
import { withLocalization } from 'hocs/localization'
import MaintenanceBanner from './MaintenanceBanner'
import { isMaintenanceModeOn, maintenanceMessage } from 'redux-app/selectors/apiData'
import { withInitialLoad } from 'shared/hocs/initialLoad'
import { profileInitialLoad } from 'redux-app/actionCreators/api'

export default compose(
  withInitialLoad(profileInitialLoad),
  connect(
    state => ({
        isMaintenanceModeOn: isMaintenanceModeOn(state),
        message: maintenanceMessage(state)
    }),
    null
  ),
  withLocalization('MaintenanceBanner')
)(MaintenanceBanner)
